import useSearchParam from "hooks/useSearchParam";

export const PROGRAM_YEAR_ID_QUERY_STRING_KEY = "programYearId";

const useSelectedProgramYearId = () =>
  useSearchParam(PROGRAM_YEAR_ID_QUERY_STRING_KEY);

export default useSelectedProgramYearId;
